import React, { Fragment } from 'react';
import {
  translate,
  Datagrid,
  Edit,
  Create,
  EditButton,
  List,
  SimpleForm,
  TextField,
  TextInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  Filter,
  BulkDeleteButton,
  NumberInput,
  BooleanInput,
  CreateButton,
  ExportButton,
  DateField,
} from 'react-admin';
import Toolbar from '@material-ui/core/Toolbar';
import DateInput from '../../../../components/DateInput';
import withStyles from '@material-ui/core/styles/withStyles';
import BookmarkIcon from '@material-ui/icons/Bookmark';

import LinkToList from './LinkToList';
import outP from '../outP';
import SendRemarkButton from './SendRemarkButton';
import resourceLocales from './locales';
import resourceConfig from './config';
import documentRowStyle from '../../../../utils/ui/documentRowStyle';
import errorModel from '../errorModel';
import objectSendModel from '../objectSendModel';
import outDocType from '../outDocType';
import outActionType from '../outActionType';
import docLink from '../docLink';
import documentImport from '../documentImport';
import exporter from '../../../../utils/exporter';
import docUpdate from '../docUpdate';
import docCheckStatus from '../docCheckStatus';
import PostPagination from '../../../../utils/pagination';
import ExportDocButton from '../docH/ExportDocButton';

const ResourceIcon = BookmarkIcon;

const listStyles = {};

const ResourceBulkActionButtons = (props) => (
  <Fragment>
    <docUpdate.Button {...props} bulk docType={'OUT'} />
    <BulkDeleteButton {...props} />
  </Fragment>
);

const ResourceListFilter = (props) => (
  <Filter {...props}>
    <TextInput source={'ids'} />
    <TextInput source={'documentNumber'} />
    <TextInput source={'guids'} />
    <TextInput source={'docnums'} />
    <TextInput source={'documentNumbers'} />
    {/* <DateInput source={'docDatesFrom'} label={`resources.${resourceConfig.name}.fields.docDatesFrom`} />
        <DateInput source={'docDateTo'} label={`resources.${resourceConfig.name}.fields.docDateTo`} /> */}
  </Filter>
);

const ChildrenPButton = (props) => {
  return (
    <outP.LinkToList
      label={`resources.${resourceConfig.name}.outP`}
      filter={{
        overEntityIds: props.record.id,
      }}
    />
  );
};

const ResourceActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
  total,
  translate,
}) => (
  <Toolbar>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems,
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    <documentImport.OpenButton params={{ docType: 'OUT' }} />
    <CreateButton basePath={basePath} to={`${basePath}/create`} />
    <ExportDocButton
      disabled={total === 0}
      resource={resource}
      sort={currentSort}
      filter={filterValues}
      exporter={exporter}
    />
  </Toolbar>
);

const ResourceList = withStyles(listStyles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={<ResourceListFilter />}
    sort={{ field: 'id', order: 'DESC' }}
    actions={<ResourceActions />}
    bulkActionButtons={<ResourceBulkActionButtons />}
    exporter={exporter}
    pagination={<PostPagination />}>
    <Datagrid rowStyle={documentRowStyle}>
      <TextField source={'id'} />

      <TextField source={'documentNumber'} />
      <TextField source={'action'} />
      <outDocType.Field source={'outDocType'} />
      <DateField source={'actionDate'} />
      <TextField source={'guid'} />
      <docCheckStatus.Field source={'checkStatus'} />
      <docLink.Field />
      <errorModel.LinkToRelatedList type={'OUT'} />
      <objectSendModel.LinkToRelatedList type={'OUT'} />
      <SendRemarkButton />
      <ChildrenPButton />
      <EditButton />
    </Datagrid>
  </List>
));

const ResourceTitle = translate(({ record, translate }) => (
  <span>
    {translate(`resources.${resourceConfig.name}.name`, { smart_count: 1 })} &quot;{record.name}
    &quot;
  </span>
));

const ResourceCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <outActionType.Input source={'action'} />
      <DateInput
        source={'actionDate'}
        label={`resources.${resourceConfig.name}.fields.actionDate`}
      />
      <TextInput source={'cancelationReason'} />
      <DateInput
        source={'cancellationDocDate'}
        label={`resources.${resourceConfig.name}.fields.cancellationDocDate`}
      />
      <TextInput source={'cancellationDocNumber'} />
      <TextInput source={'cis'} />
      {/* <TextInput source={'companyUniqName'} />
            <TextInput source={'creatorUsername'} /> */}
      <directionType source={'direction'} />
      <docStatus source={'docStatus'} />
      <TextInput source={'docnum'} />
      <DateInput
        source={'documentDate'}
        label={`resources.${resourceConfig.name}.fields.documentDate`}
      />
      <TextInput source={'documentId'} />
      <NumberInput source={'documentLinkId'} />
      <docLinkType source={'documentLinkType'} />
      <TextInput source={'documentNumber'} />
      <docStatusSystem source={'documentSystemStatus'} />
      <NumberInput source={'documentType'} />
      <errorModel.Input source={'errorModelId'} />
      <TextInput source={'inn'} />
      <DateInput source={'orderDate'} label={`resources.${resourceConfig.name}.fields.orderDate`} />
      <TextInput source={'orderNumber'} />
      <outDocType.Input source={'outDocType'} />
      <DateInput
        source={'processedDate'}
        label={`resources.${resourceConfig.name}.fields.processedDate`}
      />
      <NumberInput source={'productCost'} />
      <NumberInput source={'productTax'} />
      <TextInput source={'receiverId'} />
      <TextInput source={'requestId'} />
      <TextInput source={'subjectId'} />
      <TextInput source={'kktNumber'} />
      <TextInput source={'pdfFile'} />
      <TextInput source={'primaryDocumentCustomName'} />
      <BooleanInput source={'sendBefore'} />
      <TextInput source={'withdrawalTypeOther'} />
      <TextInput source={'destinationCountryCode'} />
      <TextInput source={'importerId'} />
      <TextInput source={'buyerInn'} />
    </SimpleForm>
  </Create>
);

const ResourceEdit = (props) => (
  <Edit redirect={null} undoable={false} title={<ResourceTitle />} {...props}>
    <SimpleForm redirect={false}>
      <TextField source={'id'} />
      <outActionType.Input source={'action'} />
      <DateInput
        source={'actionDate'}
        label={`resources.${resourceConfig.name}.fields.actionDate`}
      />
      <TextField source={'timeCreate'} />
      <TextField source={'dateCreate'} />
      <TextInput source={'cancelationReason'} />
      <DateInput
        source={'cancellationDocDate'}
        label={`resources.${resourceConfig.name}.fields.cancellationDocDate`}
      />
      <TextInput source={'cancellationDocNumber'} />
      <TextInput source={'cis'} />
      {/* <TextInput source={'companyUniqName'} />
            <TextInput source={'creatorUsername'} /> */}
      <directionType source={'direction'} />
      <docStatus source={'docStatus'} />
      <TextInput source={'docnum'} />
      <DateInput
        source={'documentDate'}
        label={`resources.${resourceConfig.name}.fields.documentDate`}
      />
      <TextInput source={'documentId'} />
      <NumberInput source={'documentLinkId'} />
      <docLinkType source={'documentLinkType'} />
      <TextInput source={'documentNumber'} />
      <docStatusSystem source={'documentSystemStatus'} />
      <NumberInput source={'documentType'} />
      <errorModel.Input source={'errorModelId'} />
      <TextInput source={'inn'} />
      <DateInput source={'orderDate'} label={`resources.${resourceConfig.name}.fields.orderDate`} />
      <TextInput source={'orderNumber'} />
      <outDocType.Input source={'outDocType'} />
      <DateInput
        source={'processedDate'}
        label={`resources.${resourceConfig.name}.fields.processedDate`}
      />
      <NumberInput source={'productCost'} />
      <NumberInput source={'productTax'} />
      <TextInput source={'receiverId'} />
      <TextInput source={'requestId'} />
      <TextInput source={'subjectId'} />
      <TextInput source={'kktNumber'} />
      <TextInput source={'pdfFile'} />
      <TextInput source={'primaryDocumentCustomName'} />
      <BooleanInput source={'sendBefore'} />
      <TextInput source={'withdrawalTypeOther'} />
      <TextInput source={'destinationCountryCode'} />
      <TextInput source={'importerId'} />
      <TextInput source={'buyerInn'} />
    </SimpleForm>
  </Edit>
);

const ResourceReferenceField = (props) => (
  <ReferenceField reference={resourceConfig.name} {...props}>
    <TextField source={'id'} />
  </ReferenceField>
);

const ResourceReferenceArrayField = (props) => (
  <ReferenceArrayField reference={resourceConfig.name} {...props}>
    <SingleFieldList>
      <ChipField source={'id'} />
    </SingleFieldList>
  </ReferenceArrayField>
);

const ResourceReferenceInput = (props) => (
  <ReferenceInput reference={resourceConfig.name} {...props}>
    <SelectInput optionText={'id'} />
  </ReferenceInput>
);

const ResourceReferenceArrayInput = (props) => (
  <ReferenceArrayInput reference={resourceConfig.name} {...props}>
    <SelectArrayInput optionText={'id'} />
  </ReferenceArrayInput>
);

export default {
  Icon: ResourceIcon,
  List: ResourceList,
  Title: ResourceTitle,
  Create: ResourceCreate,
  Edit: ResourceEdit,
  Field: ResourceReferenceField,
  ArrayField: ResourceReferenceArrayField,
  Input: ResourceReferenceInput,
  ArrayInput: ResourceReferenceArrayInput,
  LinkToList,

  name: resourceConfig.name,
  resourceConfig: {
    name: resourceConfig.name,
    list: ResourceList,
    edit: ResourceEdit,
    create: ResourceCreate,
    icon: ResourceIcon,
  },
  menuConfig: {
    name: resourceConfig.name,
    icon: ResourceIcon,
  },
  locales: resourceLocales,
  restProviderResolve: {
    name: resourceConfig.name,
    apiService: resourceConfig.apiService,
    basePath: resourceConfig.apiPath,
    schema: {
      actionDate: {
        type: 'dateTime',
      },
      cancellationDocDate: {
        type: 'dateTime',
      },
      documentDate: {
        type: 'dateTime',
      },
      orderDate: {
        type: 'dateTime',
      },
      processedDate: {
        type: 'dateTime',
      },
      dateCreate: {
        type: 'dateTime',
      },
    },
    filters: {
      actionDate: {
        type: 'dateTime',
      },
      cancellationDocDate: {
        type: 'dateTime',
      },
      documentDate: {
        type: 'dateTime',
      },
      orderDate: {
        type: 'dateTime',
      },
      processedDate: {
        type: 'dateTime',
      },
      docDatesFrom: {
        type: 'dateTime',
      },
      docDateTo: {
        type: 'dateTime',
      },
      dateCreate: {
        type: 'dateTime',
      },
    },
  },
};
